import {InjectionToken} from '@angular/core';
import {Subject} from 'rxjs';

export interface UdpBroadcastServiceInterface {
    readonly receiveMessages$: Subject<any>;

    sendUdpBroadcast(port: number, message: any): Promise<void>;
}

export const UDP_BROADCAST_SERVICE_TOKEN = new InjectionToken<UdpBroadcastServiceInterface>('udp-broadcast-service');
